const PROJECT_TYPES = {
    blockArticle: 'NEW_BLOCK_ARTICLE',
}

Object.freeze(PROJECT_TYPES)

export default PROJECT_TYPES
